/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactCookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import cookies from '../../config/cookies/cookies';
import { LOCATION_SELECTED } from '../../config/setup/setup';
import { CHANGE_LOCATION } from '../../config/text/text';
import { updateTrackingLocation } from '../../helpers/analytics';
import { onSelectLocationHelper } from '../../helpers/location';
import { setLocation } from '../../redux/actions/locations';
import WowModal from '../WowModal';
import HeaderIcon from './HeaderIcon';
import HeaderLocationList from './HeaderLocationList';

const HeaderLocation = ({ brand, site, countryCode }) => {
  const [locations, location] = useSelector((state) => [
    state.locations.locations,
    state.locations.location,
  ]);
  const hasSelection =
    typeof window === 'undefined'
      ? {}
      : localStorage.getItem(LOCATION_SELECTED);
  const lightboxLocation = ReactCookies.load(cookies.lightboxLocation);

  const locationObject = location || lightboxLocation;
  const locationName = locationObject?.shortName;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const router = useRouter();

  const onClickIcon = (show) => {
    setShowModal(show);
  };
  useEffect(() => {
    if (lightboxLocation && hasSelection !== 'set') {
      dispatch(setLocation(locationObject, true));
    }
  }, [locationName]);

  const onSelectLocation = (locationToSet) => {
    onSelectLocationHelper(locationToSet, dispatch, router, true);
    updateTrackingLocation(locationToSet.name, 'dropdown_nav');
    setShowModal(false);
  };

  return (
    <>
      <WowModal
        ariaLabelledBy="id-choose-loc"
        backdropClassName="remove-backdrop"
        extraClasses="fullscreen-mobile remove-header with-fade-in no-body-padding"
        setShowModal={setShowModal}
        showModal={showModal}
        size="lg"
      >
        <HeaderLocationList
          brand={brand}
          countryCode={countryCode}
          locations={locations}
          onCancel={() => setShowModal(false)}
          onSelectLocation={onSelectLocation}
          selection={locationObject}
          site={site}
        />
      </WowModal>

      <HeaderIcon
        aria-label={CHANGE_LOCATION}
        clickMethod={() => onClickIcon(true)}
        extraClasses="with-fade-in"
        icon="location"
        isFirst
        linkId="id-choose-loc"
      />
    </>
  );
};

HeaderLocation.propTypes = {
  brand: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  site: PropTypes.string.isRequired, // use only in storybook
};

export default HeaderLocation;
